import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Form, Input, Label, Collapse, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import {
    getStudents as onGetStudents,
    
} from "store/actions";
import debounce from "lodash.debounce";

const SearchStudent = () => {
  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    student_number: "",
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    sex: "",
    nationality: "",
    baccalaureate_year: "",
  });

  const [isOpen, setIsOpen] = useState(false);

  // Debounce pour limiter les appels API
  const debouncedSearch = debounce((filters) => {
    dispatch(onGetStudents(filters));
  }, 500);

  // déclenche la recherche quand filters change
  useEffect(() => {
    debouncedSearch(filters);
    // Cancel debounce on unmount
    return debouncedSearch.cancel;
  }, [filters]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const toggleAdvanced = () => setIsOpen(!isOpen);

  return (
    <Row>
      <Col lg={12}>
        <Card className="student-filter">
          <CardBody>
            <Form>
              <Row className="g-3">
                {/* Recherche simple */}
                <Col xxl={2} lg={2}>
                    <Label>Numéro étudiant</Label>
                    <Input
                        type="text"
                        name="student_number"
                        placeholder="Numéro étudiant"
                        value={filters.student_number}
                        onChange={handleChange}
                    />
                </Col>
                <Col xxl={2} lg={2}>
                    <Label>Matricule CNOU</Label>
                    <Input
                        type="text"
                        name="cnou_registration_number"
                        placeholder="Matricule CNOU"
                        value={filters.cnou_registration_number}
                        onChange={handleChange}
                    />
                </Col>
                <Col xxl={2} lg={2}>
                    <Label>Prénom</Label>
                    <Input
                        type="text"
                        name="first_name"
                        placeholder="Prénom"
                        value={filters.first_name}
                        onChange={handleChange}
                    />
                </Col>
                <Col xxl={2} lg={2}>
                    <Label>Nom</Label>
                    <Input
                        type="text"
                        name="last_name"
                        placeholder="Nom"
                        value={filters.last_name}
                        onChange={handleChange}
                    />
                </Col>
                <Col xxl={2} lg={2}>
                    <Label>Sexe</Label>
                    <Input type="select" name="sex" onChange={handleChange}>
                        <option value="">Tous</option>
                        <option value="M">Masculin</option>
                        <option value="F">Féminin</option>
                    </Input>
                </Col>
               

    
                {/* Recherche avancée */}
                <Collapse isOpen={isOpen} className="mt-3">
                  <Row className="g-3">
                    <Col xxl={2} lg={2}>
                        <Label>Email</Label>
                        <Input
                            type="text"
                            name="email"
                            placeholder="Email"
                            value={filters.email}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col xxl={2} lg={2}>
                        <Label>Téléphone</Label>
                        <Input
                            type="text"
                            name="phone"
                            placeholder="Téléphone"
                            value={filters.phone}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col xxl={2} lg={2}>
                        <Label>Lieu de résidence</Label>
                        <Input
                            type="text"
                            name="residence_place"
                            placeholder="Lieu de résidence"
                            value={filters.residence_place}
                            onChange={handleChange}
                        />
                    </Col>
                    <Col xxl={2} lg={2}>
                        <Label>Nationalité</Label>
                        <Input 
                            type="text"
                            name="nationality"
                            placeholder="Nationalité"
                            value={filters.nationality}
                            onChange={handleChange} 
                        />
                    </Col>

                    <Col xxl={2} lg={2}>
                        <Label>Année Bac</Label>
                        <Input
                            type="number"
                            name="baccalaureate_year"
                            placeholder="Année Bac"
                            value={filters.baccalaureate_year}
                            onChange={handleChange}
                        />
                    </Col>

                    
                  </Row>

                </Collapse>
              </Row>
              <Row className="g-3 mt-3">
              <Col xxl={3} lg={4}>
                  <div className="d-flex gap-2">
                    <Button color="primary" type="button" onClick={() => dispatch(onGetStudents(filters))}>
                      Rechercher
                    </Button>
                    <Button color="secondary" type="button" onClick={toggleAdvanced}>
                      Recherche avancée
                    </Button>
                  </div>
                </Col>
                </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default SearchStudent;
